import {
	Button,
	Dialog,
	DialogTrigger,
	Heading,
	OverlayArrow,
	Popover,
} from "react-aria-components";

import { useCompanyInfo } from "../hooks/useCompanyInfo";
import { CloseIcon } from "./icons/CloseIcon";
import { FilledCircleRightIcon } from "./icons/FilledCircleRightIcon";
import { PopoverArrowIcon } from "./icons/PopoverArrowIcon";

export const MovingAssistance = () => {
	const { companyName } = useCompanyInfo();

	return (
		<div className="tw:flex tw:flex-col tw:md:mr-4 tw:md:max-w-[400px] tw:lg:max-w-[445px]">
			<h2 className="tw:text-xs tw:leading-4 tw:font-bold tw:tracking-[0.48px] tw:text-[#E1255B] tw:uppercase tw:md:text-sm tw:md:leading-6 tw:md:tracking-[0.56px]">
				moving assistance in 30 seconds
			</h2>
			<h3 className="tw:mt-0 tw:pr-8 tw:text-2xl tw:leading-8 tw:font-extrabold tw:tracking-[-0.48px] tw:text-[#131D2B] tw:md:pr-0 tw:md:text-[2.25rem] tw:md:leading-[50px] tw:md:tracking-[-1.6px]">
				Get a Free, No Obligation Moving Quote Today from {companyName}
			</h3>
			{/* Ad Disclosure */}
			<div className="tw:mt-1 tw:mb-3">
				<DialogTrigger>
					<Button className="tw:inline-flex tw:cursor-pointer tw:appearance-none tw:items-center tw:gap-1 tw:rounded-sm tw:border-none tw:bg-transparent tw:align-middle tw:whitespace-nowrap tw:text-[#E1255B] tw:outline-hidden tw:transition-all tw:select-none tw:focus-visible:ring-3 tw:focus-visible:ring-blue-500/50 tw:disabled:cursor-not-allowed tw:md:gap-2">
						<span className="tw:text-xs tw:leading-4 tw:font-semibold tw:md:text-sm tw:md:leading-6">
							Advertiser Disclosure
						</span>
						<FilledCircleRightIcon className="tw:text-base tw:md:text-lg" />
					</Button>
					<DisclosurePopover>
						<OverlayArrow>
							<PopoverArrowIcon
								viewBox="0 0 12 12"
								className="tw:text-xl tw:text-white tw:group-placement-bottom:rotate-180"
							/>
						</OverlayArrow>
						<Dialog className="tw:rounded-xl tw:bg-white tw:p-4 tw:outline-hidden">
							{({ close }) => (
								<>
									<Button
										onPress={close}
										aria-label="Dismiss"
										className="tw:absolute tw:top-2 tw:right-6 tw:inline-flex tw:cursor-pointer tw:appearance-none tw:items-center tw:rounded-sm tw:border-none tw:bg-transparent tw:p-2 tw:align-middle tw:whitespace-nowrap tw:text-black tw:outline-hidden tw:transition-all tw:select-none tw:focus-visible:ring-3 tw:focus-visible:ring-blue-500/50 tw:disabled:cursor-not-allowed tw:md:gap-2"
									>
										<CloseIcon />
									</Button>
									<Heading
										slot="title"
										className="tw:inline-block tw:text-sm tw:leading-6 tw:font-bold tw:tracking-[-0.14px] tw:text-[#131D2B] tw:md:text-base tw:md:tracking-[-0.16px]"
									>
										BestRelocation values your trust!
									</Heading>
									<p className="tw:mt-2 tw:text-xs tw:leading-[18px] tw:text-[#22293A]">
										BestRelocation.com is a free online resource that provides
										valuable content and comparison features to visitors. To
										keep our resources 100% free for consumers,
										BestRelocation.com attempts to partner with some of the
										companies listed on this page, and may receive marketing
										compensation in exchange for clicks, purchases, and calls
										from our site. Such compensation can impact the location and
										order in which such companies appear on this page. All such
										location, order and company ratings are subject to change
										based on editorial decisions. Prices are accurate and items
										in stock as of time of publication.
									</p>
								</>
							)}
						</Dialog>
					</DisclosurePopover>
				</DialogTrigger>
			</div>
		</div>
	);
};

const DisclosurePopover = (props) => (
	<Popover
		{...props}
		className={({ isEntering, isExiting }) =>
			`tw:group tw:max-w-[366px] tw:pr-4 tw:drop-shadow-2xl tw:placement-top:mb-1 tw:placement-bottom:mt-1 ${
				isEntering
					? "tw:duration-200 tw:ease-out tw:animate-in tw:fade-in tw:slide-in-from-bottom-1 tw:placement-bottom:slide-in-from-top-1"
					: ""
			} ${
				isExiting
					? "tw:duration-150 tw:ease-in tw:animate-out tw:fade-out tw:slide-out-to-bottom-1 tw:placement-bottom:slide-out-to-top-1"
					: ""
			} `
		}
	/>
);
